
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { useNavigate } from "react-router-dom";
import { ListGroup, Table } from "react-bootstrap";
import { Row, Col, Form, Input, Label, Button, CardText, CardTitle, FormFeedback, UncontrolledTooltip } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API, setAuthToken } from "../../config/api";
import { FaUser, FaUserMd, FaGenderless, FaMailBulk, FaTransgender, FaPhone, FaAddressBook, FaAddressCard, FaEdit, FaTrash, FaSave, FaPlus, FaSearch, FaUserAlt, FaAccessibleIcon, FaCriticalRole, FaUserClock, FaUserCheck, FaAccusoft, FaArchive, FaBackspace, FaBackward, FaArrowCircleLeft, FaRegArrowAltCircleLeft, FaEyeDropper, FaRegEye, FaMehRollingEyes, FaBullseye, FaStreetView, FaEye, FaPerbyte, FaAngleUp, FaAdjust, FaMizuni, FaCreativeCommonsZero, FaCreativeCommons, FaAward, FaStethoscope, FaListOl, FaDAndD, FaDailymotion, FaGasPump, FaDesktop, FaFileMedical, FaBookMedical, FaCalendar, FaCalendarDay, FaCalendarAlt, FaTransgenderAlt, FaBirthdayCake, FaCalendarCheck, FaPhoenixFramework, FaPhoneAlt, FaPhoneSlash, FaMobile, FaMobileAlt, FaMarsStroke, FaWpforms, FaSync, FaUserPlus, FaTag, FaRegEdit, FaUserEdit, FaTable, FaMedkit, FaDeviantart, FaRegStickyNote, FaTelegramPlane } from 'react-icons/fa'
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import { FaUsersBetweenLines } from "react-icons/fa6";

import { HiUser, HiUserGroup } from "react-icons/hi2";

import Modal from 'react-bootstrap/Modal';
import logo_side from "../../assets/signature/logo-side-detail.png"
import Logo_Signature from "../../assets/signature/signature logo.png"
import Logo_Batik from "../../assets/signature/logo-batik.png"
import "bulma/css/bulma.css";
import "./Styled.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderHome from "../Loader/LoaderHome"
import ModalDataPatient from "./ModalPatientAdd/ModalAdd"
import ModalDetailPatient from "./ModalPatientDetail/ModalDetail"
import ModalPatientRelation from "./ModalRelation/Modal";
import WellcomeCard from "../Admin/Components/Wellcome";
import HeaderPatient from "./Components/HeaderPatient";
import TablePatient from "./Components/TablePatient"

export default function Login() {
  // let navigate = useNavigate();
  // useEffect(() => {
  //   if (localStorage.getItem("token") == null || undefined) {
  //       navigate("/");
  //     }
  // }, []);
  document.title = "SDC Apps";
  const navigate = useNavigate()
  const [getData, setGetData] = useState([]);
  const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);
  const [getDetailDataPatient, setGetDetailDataPatient] = useState([]);
  const [getAppointmentSSP, setGetAppointmentSSP] = useState([]);
  const [getDataPatientSsp, setGetDataPatientSsp] = useState([]);
  const [pagination, setPagination] = useState([])
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState();
  const [ascending, setAscending] = useState(0);
  const [rows, setRows] = useState(1);
  const [keyword, setKeyword] = useState("");

  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("token");
  const [idDelete, setIdDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("")
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [dataMap, setDataMap] = useState("");
  const [dataSearch, setDataSearch] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const colors = ["#A9B5DF", "#3D64FF", "#00EFB7", "#FF9090", "#FFE84D", "#00EB8D"];
  const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  // Responsive to mobile or dekstop
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1224px)' })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 980px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  const [formUpdate, setFormUpdate] = useState(false);
  const [id, setId] = useState();
  const [modalUpdateDataPatient, setModalUpdateDataPatient] = useState(false);
  const [modalDetaiDataPatient, setModalDetailPatient] = useState(false);
  const [modalDataPatientRelation, setModalPatientRelation] = useState(false);
  const [idUpdatePatient, setIdUpdatePatient] = useState(false);
  const [idDetailPatient, setIdDetailPatient] = useState();

  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };

  const GetResponseData = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`transaction-service/patients/representative/index?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${keyword}`, fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetData(response?.data?.data)
        setPage(response.data.pagination.current_page);
        setPages(response.data.pagination.total_pages);
        setRows(response.data.pagination.total);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDataProfile = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`user-service/auth/profile`, fetchParams)
      // Checking process
      if (response?.status === 200) {
        setGetDataProfileDetail(response.data.data.user_detail)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDetailPatient = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`transaction-service/patients/${idDetailPatient}`, fetchParams)
      // Checking process
      if (response?.status === 200) {
        setGetDetailDataPatient(response?.data?.data)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseDataAppointmentSSP = async () => {
    try {
      setLoading(true);
      let allData = [];
      let currentPage = 1;
      let totalPages;

      do {
        const response = await API.get(
          `user-service/appointment-ssp?page=${currentPage}&limit=${limit}&ascending=${ascending}&search=${query}`,
          fetchParams
        );

        if (response?.status === 200) {
          const { data, total_pages } = response.data;
          allData = [...allData, ...data];
          totalPages = total_pages;
        }
        currentPage++;
      } while (currentPage <= totalPages);
      const ids = allData?.map((data) => data.id_patient);
      setGetAppointmentSSP(ids);
    } catch (error) {
      swal({
        title: "Failed",
        text: `${error.response?.data?.message || "Terjadi kesalahan"}`,
        icon: "error",
        timer: 3000,
        buttons: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteById = async (id) => {
    Swal.fire({
      title: 'Apakah Kamu Yakin?',
      text: `Menghapus data ini`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await API.delete(`transaction-service/patients/${id}`, fetchParams);
        if (response.data.error === false) {
          GetResponseData()
          swal({
            title: 'Success',
            text: "Your data has been successfully deleted",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }
      }
    })
  };

  const changePage = ({ selected }) => {
    setPage(selected + 1);
    if (selected === 10) {
      setMsg(
        ""
      );
    } else {
      setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };

  useEffect(() => {
    if (idDetailPatient) {
      GetResponseDetailPatient();
    } else {
      GetResponseData()
      GetResponseDataAppointmentSSP();
      GetResponseDataProfile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idDetailPatient, page, limit, keyword, ascending])

  const buttonRefresh = () => {
    window.location.reload();
  };

  const odontogramPatient = (id, first_name, last_name) => {
    navigate('/odontograms/' + id + "/" + first_name + "/" + last_name);
  };

  const soapPatient = (id, first_name, last_name) => {
    navigate('/soap-patients/' + id + "/" + first_name + "/" + last_name);
  };

  let modalPhysicalCheck = async (id) => {
    navigate('/phy-checks/' + id)
  };

  let modalRepresentative = async (id) => {
    navigate('/representative/' + id)
  };

  let modalMedicalRecord = async (id, code) => {
    navigate('/medical-record/' + id + "/" + code)
  };

  let modalSatuSehat = async (id) => {
    navigate('/satu-sehat/' + id)
  };

  const updateUser = (id) => {
    navigate('/representative/profile/' + id)
  }

  const modalMedisRoleAdd = (id_patient) => {
    setModalUpdateDataPatient(true)
    setIdUpdatePatient(id_patient)
  }

  const modalDetailPatient = (id) => {
    setModalDetailPatient(true)
    setIdDetailPatient(id)
  }

  const modalPatientRelation = () => {
    setModalPatientRelation(true)
  }

  return (
    <>
      <Row>
        <WellcomeCard
          getDataProfileNull={getDataProfileDetail === null}
          getDataProfileFirstName={getDataProfileDetail?.firstname}
          getDataProfileLastName={getDataProfileDetail?.lastname}
        />
      </Row>
      <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
        {modalUpdateDataPatient && <ModalDataPatient GetResponseData={GetResponseData} idUpdatePatient={idUpdatePatient} show={modalUpdateDataPatient} onHide={() => setModalUpdateDataPatient(false)} />}
        {modalDetaiDataPatient && <ModalDetailPatient GetResponseData={GetResponseDetailPatient} getDetailDataPatient={getDetailDataPatient} idDetailPatient={idDetailPatient} show={modalDetaiDataPatient} onHide={() => setModalDetailPatient(false)} />}
        {modalDataPatientRelation &&
          <ModalPatientRelation
            GetResponseData={GetResponseData}
            show={modalDataPatientRelation}
            onHide={() => setModalPatientRelation(false)}
          />
        }

        {loading && <LoaderHome />}

        {isTabletOrMobile ?
          <>
            {/* header */}
            <HeaderPatient
              isTabletOrMobile={isTabletOrMobile}
              query={query}
              setQuery={setQuery}
              limit={limit}
              setLimit={setLimit}
              viewModalAdd={modalMedisRoleAdd}
              buttonRefresh={buttonRefresh}
              searchData={searchData}
              handleModalRelationPatient={modalPatientRelation}
              showCustomButtonRelationPatient={true}
            />
            {/* end header */}
            <Col xl='12' sm='12'>
              <div>
                {/* start table */}
                <TablePatient
                  getData={getData}
                  rows={rows}
                  page={page}
                  pages={pages}
                  changePage={changePage}
                  msg={msg}
                  modalPhysicalCheck={modalPhysicalCheck}
                  modalDetailPatient={modalDetailPatient}
                  modalMedicalRecord={modalMedicalRecord}
                  modalRepresentative={modalRepresentative}
                  soapPatient={soapPatient}
                  odontogramPatient={odontogramPatient}
                  getAppointmentSSP={getAppointmentSSP}
                  deleteById={deleteById}
                  updateUser={updateUser}
                  isTabletOrMobile={isTabletOrMobile}
                />
                {/* end table */}
              </div>
            </Col>
          </>
          :
          <>
            {/* header */}
            <HeaderPatient
              isTabletOrMobile={isTabletOrMobile}
              query={query}
              setQuery={setQuery}
              limit={limit}
              setLimit={setLimit}
              viewModalAdd={modalMedisRoleAdd}
              buttonRefresh={buttonRefresh}
              searchData={searchData}
              handleModalRelationPatient={modalPatientRelation}
              showCustomButtonRelationPatient={true}
            />
            {/* end header */}
            <Col xl='12' sm='12'>
              <div>
                {/* start table */}
                <TablePatient
                  getData={getData}
                  rows={rows}
                  page={page}
                  pages={pages}
                  changePage={changePage}
                  msg={msg}
                  modalPhysicalCheck={modalPhysicalCheck}
                  modalDetailPatient={modalDetailPatient}
                  modalMedicalRecord={modalMedicalRecord}
                  modalRepresentative={modalRepresentative}
                  soapPatient={soapPatient}
                  odontogramPatient={odontogramPatient}
                  modalSatuSehat={modalSatuSehat}
                  getAppointmentSSP={getAppointmentSSP}
                  deleteById={deleteById}
                  updateUser={updateUser}
                  isTabletOrMobile={isTabletOrMobile}
                />
                {/* end table */}
              </div>
            </Col>
          </>
        }
      </div>
    </>
  );
}
